import { createStore } from "vuex";
import app from "@/store/modules/app";
import auth from "@/store/modules/auth";
import wallet from "@/store/modules/wallet";
import toast from "@/store/modules/toast";
import qrCodeWallet from "@/store/modules/qrCodeWallet";
import removeWallet from "@/store/modules/removeWallet";
import importWallet from "@/store/modules/importWallet";
import ethereum from "@/store/modules/ethereum";
import fourMeme from "@/store/modules/fourMeme";
import exportWallet from "@/store/modules/exportWallet";
import holderDistribution from "@/store/modules/holderDistribution";
import solana from "@/store/modules/solana";
import network from "@/store/modules/network";

export default createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    app: app,
    toast: toast,
    auth: auth,
    wallet: wallet,
    network: network,
    ethereum: ethereum,
    fourMeme: fourMeme,
    solana: solana,
    qrCodeWallet: qrCodeWallet,
    removeWallet: removeWallet,
    importWallet: importWallet,
    exportWallet: exportWallet,
    holderDistribution: holderDistribution,
  },
});
